import { connect } from 'react-redux';
import * as resumeActions from 'redux-modules/resume/actions.js';
import * as resumeSelectors from 'redux-modules/resume/selectors.js';
import * as metaSelectors from 'redux-modules/meta/selectors.js';
import Availability from './Availability';

function mapStateToProps(state) {
  return {
    availability: resumeSelectors.selectAvailability(state),
    loading: resumeSelectors.selectLoadState(state),
    meta: metaSelectors.selectMeta(state),
    syncErrors: resumeSelectors.selectSyncError(state),
    syncing: resumeSelectors.selectSyncState(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSave: (data, failCallback) => dispatch(resumeActions.saveAvailability(data, failCallback))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Availability);
